<script>
import EditScheduleDate from './CalendarEditDate';
import mixins from '../../../shared/mixins/calendar-mixins';
import CalendarPortal from '../../../shared/mixins/calendar-portal';
import CreateNewCalendarItem from '../partials/CreateNewCalendarItem';
import ShareScheduleModal from '../partials/ShareScheduleModal';
import AssetCalendarCell from '../partials/TeamCalendarCell';
import Query from '@jgile/laravel-vue/resources/js/lib/Query';

const AssetCalendarCellClass = Vue.extend(AssetCalendarCell);
const CalendarPortalClass = Vue.extend(CalendarPortal);

export default {
    mixins: [mixins],
    props: ['schedule'],
    components: { EditScheduleDate, CreateNewCalendarItem, ShareScheduleModal },
    data() {
        return {
            query: new Query({
                perPage: 1000000,
                include: 'category,asset',
                filter: {
                    name: [],
                    category: [],
                    status: [],
                    not_denied: true,
                },
            }),
            includes: {
                tasks: true,
                reminders: true,
            },
            editDate: null,
            loadEditor: false,
            calendarConfig: {
                unselectCancel: '.popper, .popper *, .multiselect__single',
            },
        };
    },
    watch: {
        includes: {
            deep: true,
            handler() {
                this.refetchEvents();
            },
        },
        'calendar.loadSchedule': {
            handler() {
                this.refetchEvents();
            },
        },
        'query.filter': {
            deep: true,
            handler() {
                this.refetchEvents();
            },
        },
    },
    created() {
        this.calendar.singleDaySelect = true;
        Bus.$on('scheduleDateUpdated', this.refetchEvents);
        Bus.$on('scheduleDateCreated', this.refetchEvents);
    },
    methods: {
        eventRender(event, element) {
            let inner = document.createElement('DIV');
            // inner.className = 'calendar-cell';

            if (event.render_template === 'reminder') {
                const instance = new CalendarPortalClass({
                    propsData: {
                        name: 'tasksModal',
                        slotProps: { event: event },
                    },
                });
                instance.$mount();
                inner.append(instance.$el);
            } else if (event.render_template === 'task') {
                const instance = new CalendarPortalClass({
                    propsData: {
                        name: 'tasksModal',
                        slotProps: { event: event },
                    },
                });
                instance.$mount();
                inner.append(instance.$el);
            } else if (event.render_template === 'assets') {
                const instance = new CalendarPortalClass({
                    propsData: {
                        name: 'calendarAssets',
                        slotProps: { event: event },
                    },
                });
                instance.$mount();
                inner.append(instance.$el);
            } else if (event.rendering === 'background') {
                const instance = new AssetCalendarCellClass({
                    propsData: {
                        event: event,
                        element: element,
                        leadTime: this.leadTime,
                    },
                });
                instance.$mount();
                inner.append(instance.$el);
            }

            element.html(inner);
        },
        getTasks(start, end) {
            const self = this;
            return new Promise(function (resolve) {
                axios
                    .get('/api/tasks', {
                        params: {
                            perPage: 100000,
                            filter: {
                                between_dates: start.format() + ',' + end.format(),
                            },
                        },
                    })
                    .then((response) => {
                        let reminders = self.includes.reminders
                            ? _.chain(response.data.data)
                                  .filter((item) => {
                                      return item.remind_at;
                                  })
                                  .groupBy((item) => dateTimeString(item.due_at, 'date', true, true))
                                  .map((items, key) => {
                                      return {
                                          id: 'calendarReminder' + key,
                                          title: ' ',
                                          start: key,
                                          end: key,
                                          data: items,
                                          render_template: 'reminder',
                                          className: ['calendar-reminders'],
                                      };
                                  })
                                  .value()
                            : {};

                        let tasks = self.includes.tasks
                            ? _.chain(response.data.data)
                                  .filter((item) => {
                                      return !item.remind_at;
                                  })
                                  .groupBy((item) => dateTimeString(item.due_at, 'date', true, true))
                                  .map((items, key) => {
                                      return {
                                          id: 'calendarTasks' + key,
                                          title: ' ',
                                          start: key,
                                          end: key,
                                          data: items,
                                          render_template: 'task',
                                          className: ['calendar-tasks'],
                                      };
                                  })
                                  .value()
                            : {};

                        resolve(_.concat(reminders, tasks));
                    });
            });
        },
        getCalendarAssets(start, end) {
            const self = this;

            return new Promise(function (resolve) {
                self.query.filter.between_dates = start.format() + ',' + end.format();

                self.query.get('/api/order-items').then((response) => {
                    let items = _.chain(response.data)
                        .groupBy('start_date')
                        .map((items, key) => {
                            let assets = _.chain(items)
                                .reduce((sum, item) => {
                                    if (!sum[item.asset_id]) {
                                        sum[item.asset_id] = {
                                            name: item.name,
                                            uuid: item.order.uuid,
                                            team: item.team_name,
                                            unit_increment_text: item.unit_increment_text,
                                            category_name: item.category_name,
                                            orderItemIds: [item.id],
                                            advertiser: item.advertiser_name,
                                            start_date: key,
                                            end_date: key,
                                            units: 0,
                                            price: 0,
                                        };
                                    }

                                    if (!_.includes(sum[item.asset_id]['orderItemIds'], item.id)) {
                                        sum[item.asset_id]['orderItemIds'].push(item.id);
                                    }

                                    sum[item.asset_id]['units'] += item.units;
                                    sum[item.asset_id]['price'] += item.units * item.price;

                                    return sum;
                                }, {})
                                .values()
                                .value();

                            return {
                                id: 'assets' + key,
                                title: assets.length + ' assets',
                                start: key,
                                end: key,
                                data: assets,
                                render_template: 'assets',
                                className: ['calendar-assets'],
                            };
                        })
                        .value();

                    resolve(items);
                });
            });
        },
        getCalendarData(start, end, timezone, callback) {
            const self = this;
            this.$messenger.loading();
            const calendarItems = this.getTasks(start, end);
            const calendarAssets = this.getCalendarAssets(start, end);
            return Promise.all([calendarItems, calendarAssets]).then(function (values) {
                self.$messenger.loaded();
                self.calendar.events = [].concat.apply([], values);
                callback(self.calendar.events);
            });
        },
        calendarUnselectionMade() {
            this.calendar.haveSelection = false;
            this.loadEditor = false;
        },
        onCalendarSelection(e) {
            this.editDate = null;
            this.loadEditor = null;
            this.$nextTick(function () {
                this.editDate = _.get(this.calendar, 'selectedScheduleDate');
                this.loadEditor = true;
            });
        },
    },
};
</script>
